module.exports = __webpack_public_path__ + "img/sos2.abf955e4.svg";